;(function() {
  if (window.ckVariantGalleryFixLoaded) return;
  window.ckVariantGalleryFixLoaded = true;

  function isImageFileHref(href) {
    return /\.(jpe?g|png|webp|gif)(\?|$)/i.test(String(href || '').split('#')[0]);
  }

  function installDirectImageLinkGuard() {
    if (window.ckProductThumbDirectLinkGuard) return;
    window.ckProductThumbDirectLinkGuard = true;

    document.addEventListener('click', function(event) {
      var link = event.target && event.target.closest && event.target.closest('a.product__thumb[href]');
      if (!link || !isImageFileHref(link.getAttribute('href'))) return;

      event.preventDefault();
    }, true);
  }

  function cleanFile(src) {
    return String(src || '')
      .split('?')[0]
      .split('/')
      .pop()
      .replace(/_(pico|icon|thumb|small|compact|medium|large|grande|\d+x\d+|master)(?=\.)/, '');
  }

  function productContainer(el) {
    return el.closest('[data-section-type="product"]') || el.closest('.product-section') || document;
  }

  function isObservableContainer(container) {
    return Boolean(
      container &&
      typeof container.nodeType === 'number' &&
      typeof container.querySelectorAll === 'function'
    );
  }

  function ensureGalleryFilterStyle() {
    if (document.getElementById('ck-variant-gallery-filter-style')) return;
    var style = document.createElement('style');
    style.id = 'ck-variant-gallery-filter-style';
    style.textContent = [
      '.product__thumb-item.ck-color-hidden{display:none!important;visibility:hidden!important;pointer-events:none!important;}',
      '.product-main-slide.ck-color-hidden{display:none!important;visibility:hidden!important;pointer-events:none!important;}',
      '.ck-gallery-hidden-deck{display:none!important;visibility:hidden!important;}',
      '.product-slideshow.ck-gallery-height-locked .flickity-viewport{height:var(--ck-gallery-min-height,auto)!important;min-height:var(--ck-gallery-min-height,0px)!important;}',
      '.ck-gallery-count-pill,.ck-gallery-dots{display:none;}',
      '@media only screen and (min-width:769px){.product__thumbs--beside.ck-single-visible-thumb{display:block!important;visibility:visible!important;}.product__thumbs--beside.ck-multiple-visible-thumbs .product__thumbs--scroller,.product__thumbs--beside.ck-single-visible-thumb .product__thumbs--scroller{box-sizing:border-box!important;padding-top:30px!important;padding-bottom:30px!important;}.product__thumbs--beside .product__thumb-item{width:100%!important;max-width:80px!important;}.product__thumbs--beside .product__thumb{background:#fff;overflow:hidden;}.product__thumbs--beside .product__thumb .image-wrap{display:flex!important;align-items:center!important;justify-content:center!important;aspect-ratio:1/1!important;height:auto!important;padding-bottom:0!important;background:#fff!important;}.product__thumbs--beside .product__thumb image-element{display:block!important;width:100%!important;height:100%!important;opacity:1!important;}.product__thumbs--beside .product__thumb img{display:block!important;width:100%!important;height:100%!important;position:static!important;object-fit:contain!important;opacity:1!important;}}',
      '@media only screen and (max-width:768px){.ck-gallery-indicator-frame{position:relative;}.ck-gallery-indicator-frame .ck-gallery-count-pill{display:flex;position:absolute;top:10px;right:10px;z-index:4;align-items:center;justify-content:center;min-width:42px;height:24px;padding:0 9px;border-radius:999px;background:rgba(30,47,53,.72);color:#fff;font-size:12px;font-weight:600;line-height:1;letter-spacing:0;box-shadow:0 1px 6px rgba(0,0,0,.12);backdrop-filter:blur(4px);pointer-events:none;}.ck-gallery-indicator-frame .ck-gallery-dots{display:flex;align-items:center;justify-content:center;gap:6px;height:20px;margin:7px 0 3px;}.ck-gallery-indicator-frame .ck-gallery-dot{display:block;width:6px;height:6px;border-radius:999px;background:rgba(30,47,53,.28);transition:width .18s ease,background-color .18s ease;}.ck-gallery-indicator-frame .ck-gallery-dot.is-active{width:18px;background:#1e2f35;}.ck-gallery-indicator-frame .ck-gallery-count-pill[hidden],.ck-gallery-indicator-frame .ck-gallery-dots[hidden]{display:none!important;}}'
    ].join('');
    document.head.appendChild(style);
  }

  function variantsFor(container) {
    var json = container.querySelector('[data-variant-json]');
    if (!json) return [];
    try {
      return JSON.parse(json.textContent || json.value || '[]');
    } catch (e) {
      return [];
    }
  }

  function selectedOptions(container) {
    var values = {};
    container.querySelectorAll('[data-variant-input]').forEach(function(input) {
      var type = input.getAttribute('type');
      var index = input.dataset.index;
      if (!index) return;
      if ((type === 'radio' || type === 'checkbox') && !input.checked) return;
      values[index] = input.value;
    });

    return [values.option1, values.option2, values.option3].filter(function(value) {
      return value != null && value !== '';
    });
  }

  function selectedVariant(container) {
    var selected = selectedOptions(container);
    var match = variantsFor(container).find(function(variant) {
      return selected.every(function(value, index) {
        return variant['option' + (index + 1)] === value;
      });
    });

    if (match) return match;

    var select = container.querySelector('[data-product-select]');
    var selectedId = select && select.value;
    if (!selectedId) return null;
    return variantsFor(container).find(function(variant) {
      return String(variant.id) === String(selectedId);
    }) || null;
  }

  function handleizeToken(value) {
    var normalized = String(value || '').toLowerCase();
    if (normalized.normalize) {
      normalized = normalized.normalize('NFKD').replace(/[\u0300-\u036f]/g, '');
    }
    return normalized
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function containsAny(normalized, compact, terms) {
    return terms.some(function(term) {
      var value = String(term || '').toLowerCase();
      return normalized.indexOf(value) !== -1 || compact.indexOf(handleizeToken(value)) !== -1;
    });
  }

  function colorMarkerToken(normalized) {
    var marker = String(normalized || '').match(/(?:^|[^a-z0-9])color[_-]([a-z0-9-]+)/);
    return marker && marker[1] ? marker[1].replace(/-+$/g, '') : '';
  }

  function colorToken(value) {
    var normalized = String(value || '').toLowerCase();
    var compact = handleizeToken(normalized);
    if (
      (
        normalized.indexOf('reflect wheel') !== -1 ||
        normalized.indexOf('reflect-wheel') !== -1 ||
        normalized.indexOf('reflective wheel') !== -1 ||
        normalized.indexOf('reflective-wheel') !== -1 ||
        normalized.indexOf('wheel kit') !== -1 ||
        normalized.indexOf('wheel-kit') !== -1 ||
        normalized.indexOf('relfectors') !== -1 ||
        normalized.indexOf('refelctors') !== -1 ||
        normalized.indexOf('reflectors') !== -1
      ) &&
      normalized.indexOf('leg rest') === -1 &&
      normalized.indexOf('leg-rest') === -1 &&
      normalized.indexOf('legrest') === -1
    ) {
      return '';
    }

    var marker = colorMarkerToken(normalized);
    if (marker) return marker;

    if (containsAny(normalized, compact, ['graphite glacier'])) return 'graphite-glacier';
    if (containsAny(normalized, compact, ['navy glacier'])) return 'navy-glacier';
    if (containsAny(normalized, compact, ['onyx glacier'])) return 'onyx-glacier';
    if (containsAny(normalized, compact, ['glacier onyx'])) return 'glacier-onyx';
    if (containsAny(normalized, compact, ['graphite onyx'])) return 'graphite-onyx';
    if (containsAny(normalized, compact, ['jade onyx'])) return 'jade-onyx';
    if (containsAny(normalized, compact, ['raven black'])) return 'raven-black';
    if (containsAny(normalized, compact, ['sand onyx'])) return 'sand-onyx';
    if (containsAny(normalized, compact, ['teak'])) return 'teak';
    if (containsAny(normalized, compact, ['blush pink'])) return 'blush-pink';
    if (containsAny(normalized, compact, ['desert green'])) return 'desert-green';
    if (containsAny(normalized, compact, ['grey hound', 'greyhound'])) return 'greyhound';
    if (containsAny(normalized, compact, ['ocean blue'])) return 'ocean-blue';
    if (containsAny(normalized, compact, ['racing green'])) return 'racing-green';
    if (containsAny(normalized, compact, ['royal blue'])) return 'royal-blue';
    if (containsAny(normalized, compact, ['sahara sand'])) return 'sahara-sand';
    if (containsAny(normalized, compact, ['flame red'])) return 'flame-red';
    if (containsAny(normalized, compact, ['gold'])) return 'gold';
    if (containsAny(normalized, compact, ['midnight'])) return 'midnight';
    if (containsAny(normalized, compact, ['vacation'])) return 'vacation';
    if (containsAny(normalized, compact, ['nitro black'])) return 'nitro-black';
    if (containsAny(normalized, compact, ['delightful grey'])) return 'delightful-grey';
    if (containsAny(normalized, compact, ['lovely taupe'])) return 'lovely-taupe';
    if (containsAny(normalized, compact, ['mighty green'])) return 'mighty-green';
    if (containsAny(normalized, compact, ['navy blue'])) return 'navy-blue';
    if (containsAny(normalized, compact, ['sage green'])) return 'sage-green';
    if (containsAny(normalized, compact, ['space black'])) return 'space-black';
    if (containsAny(normalized, compact, ['stone grey', 'stone gray'])) return 'stone-grey';
    if (containsAny(normalized, compact, ['anthony', ' ath', '-ath', '_ath', 'white grey chenille', 'white and grey chenille'])) return 'anthony';
    if (containsAny(normalized, compact, ['ada'])) return 'ada';
    if (containsAny(normalized, compact, ['callum', ' clm', '-clm', '_clm'])) return 'callum';
    if (containsAny(normalized, compact, ['declan', ' dcl', '-dcl', '_dcl', 'oat melange'])) return 'declan';
    if (containsAny(normalized, compact, ['dillan', ' dln', '-dln', '_dln'])) return 'dillan';
    if (containsAny(normalized, compact, ['evelyn', ' evn', '-evn', '_evn'])) return 'evelyn';
    if (containsAny(normalized, compact, ['james'])) return 'james';
    if (containsAny(normalized, compact, ['kenzi', ' knz', '-knz', '_knz'])) return 'kenzi';
    if (containsAny(normalized, compact, ['lucy', ' lcy', '-lcy', '_lcy', 'rosewood melange'])) return 'lucy';
    if (containsAny(normalized, compact, ['owen'])) return 'owen';
    if (containsAny(normalized, compact, ['savannah', ' sav', '-sav', '_sav'])) return 'savannah';
    if (
      normalized.indexOf('color_jake') !== -1 ||
      normalized.indexOf('color-jake') !== -1 ||
      normalized.indexOf('jake') !== -1 ||
      normalized.indexOf('jke') !== -1
    ) {
      return 'jake';
    }
    if (
      normalized.indexOf('color_gwen') !== -1 ||
      normalized.indexOf('color-gwen') !== -1 ||
      normalized.indexOf('gwen') !== -1 ||
      normalized.indexOf('gwn') !== -1 ||
      normalized.indexOf('green-melange') !== -1 ||
      normalized.indexOf('green melange') !== -1
    ) {
      return 'gwen';
    }
    if (
      normalized.indexOf('color_greyson') !== -1 ||
      normalized.indexOf('color-greyson') !== -1 ||
      normalized.indexOf('greyson') !== -1 ||
      normalized.indexOf('grayson') !== -1 ||
      normalized.indexOf('charcoal-melange') !== -1 ||
      normalized.indexOf('charcoal melange') !== -1 ||
      normalized.indexOf('0320-vis-gry') !== -1 ||
      normalized.indexOf('v2-gry') !== -1
    ) {
      return 'greyson';
    }
    if (
      normalized.indexOf('color_noa') !== -1 ||
      normalized.indexOf('color-noa') !== -1 ||
      normalized.indexOf('noa') !== -1 ||
      normalized.indexOf('0320-vis-noa') !== -1
    ) {
      return 'noa';
    }
    if (
      normalized.indexOf('axiom-improv-red-right') !== -1 ||
      normalized.indexOf('3143c087e21c1af18339e8cbc91d22fd') !== -1 ||
      normalized.indexOf('dabaf47a93172be5ef6a656e4bf7fa9b') !== -1
    ) {
      return 'red';
    }
    if (
      normalized.indexOf('axiom-improv-blue-navy') !== -1 ||
      normalized.indexOf('591bd2298de45cb647daf69265980879') !== -1 ||
      normalized.indexOf('1ecfda212a996b0e36f2e3936e4bf8ca') !== -1 ||
      normalized.indexOf('de042627a91e8941fec2a01868541534') !== -1 ||
      normalized.indexOf('b23e154237cff2fe778c18d36cd9839a') !== -1
    ) {
      return 'navy';
    }
    if (
      normalized.indexOf('majolica blue') !== -1 ||
      normalized.indexOf('majolica-blue') !== -1 ||
      normalized.indexOf('majolica') !== -1 ||
      normalized.indexOf('11300103') !== -1
    ) {
      return 'majolica-blue';
    }
    if (
      normalized.indexOf('shadow grey') !== -1 ||
      normalized.indexOf('shadow-gray') !== -1 ||
      normalized.indexOf('shadow-grey') !== -1 ||
      normalized.indexOf('11300102') !== -1
    ) {
      return 'shadow-grey';
    }
    if (
      normalized.indexOf('misty rose') !== -1 ||
      normalized.indexOf('misty-rose') !== -1 ||
      normalized.indexOf('11300208') !== -1
    ) {
      return 'misty-rose';
    }
    if (
      normalized.indexOf('olive') !== -1 ||
      normalized.indexOf('11300104') !== -1
    ) {
      return 'olive';
    }
    if (
      normalized.indexOf('grey melange') !== -1 ||
      normalized.indexOf('gray melange') !== -1 ||
      normalized.indexOf('grey-melange') !== -1 ||
      normalized.indexOf('gray-melange') !== -1 ||
      normalized.indexOf('11300205') !== -1
    ) {
      return 'grey-melange';
    }
    if (
      normalized.indexOf('black/black') !== -1 ||
      normalized.indexOf('black-black') !== -1 ||
      normalized.indexOf('black') !== -1 ||
      normalized.indexOf('11300201') !== -1
    ) {
      return 'black';
    }
    if (normalized.indexOf('red') !== -1) return 'red';
    if (normalized.indexOf('orange') !== -1) return 'orange';
    if (normalized.indexOf('purple') !== -1) return 'purple';
    if (normalized.indexOf('pink') !== -1) return 'pink';
    if (normalized.indexOf('green') !== -1) return 'green';
    if (normalized.indexOf('grey') !== -1 || normalized.indexOf('gray') !== -1) return 'grey';
    if (normalized.indexOf('navy') !== -1 || normalized.indexOf('blue') !== -1) return 'navy';
    return '';
  }

  function hasColorSwatches(container) {
    return Boolean(container && container.querySelector && container.querySelector('label.color-swatch, .variant__button-label.color-swatch'));
  }

  function variantColorToken(variant, container) {
    if (!variant) return '';
    var options = [variant.option1, variant.option2, variant.option3].filter(function(option) {
      return option && option !== 'Default Title';
    });
    var known = colorToken(options.join(' '));
    if (known) return known;
    if (options.length === 1 && hasColorSwatches(container)) {
      return handleizeToken(options[0]);
    }
    return '';
  }

  function variantImageSrc(variant) {
    return variant && variant.featured_image && variant.featured_image.src ? variant.featured_image.src : '';
  }

  function closestGroup(el) {
    if (!el || !el.closest) return '';
    var group = el.closest('[data-group]');
    return group ? group.getAttribute('data-group') : '';
  }

  function displaySrc(src) {
    if (!src) return '';
    return src + (src.indexOf('?') === -1 ? '?width=900' : '&width=900');
  }

  var THULE_SPRING_PATH = '/products/thule-spring-stroller';
  var THULE_WHEEL_KIT_IMAGE = 'https://cdn.shopify.com/s/files/1/0078/5393/2596/files/thule-spring-reflect-wheel-kit-included.png?v=1782749501';
  var THULE_WHEEL_KIT_ALT = 'Free Thule Spring Reflect Wheel Kit included with every color';

  function isThuleSpringMainListing() {
    return window.location && window.location.pathname.replace(/\/$/, '') === THULE_SPRING_PATH;
  }

  function thuleSpringFileMatchesColor(file, selectedColor) {
    if (!isThuleSpringMainListing() || !file || !selectedColor) return false;
    var normalizedFile = cleanFile(file).toLowerCase();
    var color = String(selectedColor || '').toLowerCase();
    var colorFiles = {
      'black': [
        'thule-spring-stroller-black-2.jpg',
        'thule-spring-stroller-black-46.jpg'
      ],
      'majolica-blue': [
        'thule-spring-stroller-majolica-blue-16.jpg',
        'thule-spring-stroller-majolica-blue-26.jpg'
      ],
      'shadow-grey': [
        'thule-spring-stroller-shadow-grey-16.jpg',
        'thule-spring-stroller-shadow-grey-26.jpg'
      ],
      'misty-rose': [
        'thule-spring-stroller-misty-rose-103_87e3a76f-de78-4c9f-adad-f87635f2899a.jpg'
      ],
      'olive': [
        'thule-spring-stroller-olive-16.jpg',
        'thule-spring-stroller-olive-21.jpg'
      ],
      'grey-melange': [
        'thule-spring-stroller-black-grey-melange-16.jpg',
        'thule-spring-stroller-black-grey-melange-26.jpg'
      ]
    };

    return Boolean(colorFiles[color] && colorFiles[color].indexOf(normalizedFile) !== -1);
  }

  function isWheelKitMediaText(value) {
    var text = String(value || '').toLowerCase();
    return (
      text.indexOf('thule-spring-reflect-wheel-kit-included') !== -1 ||
      text.indexOf('reflect wheel') !== -1 ||
      text.indexOf('reflective wheel') !== -1 ||
      text.indexOf('wheel kit') !== -1 ||
      text.indexOf('wheel-kit') !== -1 ||
      text.indexOf('relfectors') !== -1 ||
      text.indexOf('refelctors') !== -1
    ) && text.indexOf('leg rest') === -1 && text.indexOf('leg-rest') === -1 && text.indexOf('legrest') === -1;
  }

  function elementLooksLikeWheelKit(node) {
    if (!node) return false;
    var image = node.querySelector && node.querySelector('img');
    var link = node.querySelector && node.querySelector('a[href]');
    return isWheelKitMediaText([
      node.getAttribute && node.getAttribute('data-group'),
      node.getAttribute && node.getAttribute('data-media-id'),
      image && image.getAttribute('alt'),
      image && image.getAttribute('src'),
      image && image.getAttribute('srcset'),
      image && image.currentSrc,
      link && link.getAttribute('href')
    ].join(' '));
  }

  function makeMediaElementShared(node) {
    if (!node) return;
    node.classList.remove('hide');
    node.classList.remove('ck-color-hidden');
    node.classList.remove('is-selected');
    node.hidden = false;
    node.style.removeProperty('display');
    node.style.removeProperty('visibility');
    node.style.removeProperty('pointer-events');
    node.removeAttribute('aria-hidden');
    node.removeAttribute('tabindex');
  }

  function setWheelKitImage(node) {
    if (!node) return;
    var link = node.querySelector && node.querySelector('a[href]');
    if (link) {
      link.setAttribute('href', THULE_WHEEL_KIT_IMAGE);
      link.removeAttribute('data-group');
    }

    Array.prototype.forEach.call(node.querySelectorAll ? node.querySelectorAll('img') : [], function(image) {
      image.setAttribute('alt', THULE_WHEEL_KIT_ALT);
      image.setAttribute('src', displaySrc(THULE_WHEEL_KIT_IMAGE));
      image.removeAttribute('srcset');
      image.removeAttribute('data-srcset');
      image.removeAttribute('data-src');
      image.removeAttribute('data-group');
    });
  }

  function ensureThuleSpringWheelKitSlide(container) {
    if (!isThuleSpringMainListing()) return;

    var slider = gallerySlider(container);
    if (!slider) return;

    var flkty = window.Flickity && window.Flickity.data(slider);
    var slideParent = (flkty && flkty.slider) || slider.querySelector('.flickity-slider') || slider;
    var existingSlide = Array.prototype.slice.call(slider.querySelectorAll('.product-main-slide')).find(elementLooksLikeWheelKit);
    if (existingSlide) {
      if (existingSlide.parentNode !== slideParent) {
        slideParent.appendChild(existingSlide);
      }
      makeMediaElementShared(existingSlide);
      setWheelKitImage(existingSlide);
    } else {
      var templateSlide = slider.querySelector('.product-main-slide.secondary-slide') || slider.querySelector('.product-main-slide');
      if (templateSlide) {
        var slide = templateSlide.cloneNode(true);
        makeMediaElementShared(slide);
        slide.classList.remove('starting-slide');
        slide.classList.add('secondary-slide');
        slide.classList.add('ck-shared-promo-slide');
        slide.setAttribute('data-media-id', 'ck-thule-wheel-kit');
        slide.setAttribute('data-index', String(slider.querySelectorAll('.product-main-slide').length));
        setWheelKitImage(slide);
        slideParent.appendChild(slide);
      }
    }

    var rail = container.querySelector('[data-product-thumbs]');
    var thumbWrap = rail && (rail.querySelector('.product__thumbs--scroller') || rail);
    if (!thumbWrap) return;

    var existingThumb = Array.prototype.slice.call(thumbWrap.querySelectorAll('.product__thumb-item')).find(elementLooksLikeWheelKit);
    if (existingThumb) {
      makeMediaElementShared(existingThumb);
      setWheelKitImage(existingThumb);
      return;
    }

    var templateThumb = thumbWrap.querySelector('.product__thumb-item');
    if (!templateThumb) return;
    var thumb = templateThumb.cloneNode(true);
    makeMediaElementShared(thumb);
    thumb.classList.add('ck-shared-promo-thumb');
    thumb.removeAttribute('data-index');
    setWheelKitImage(thumb);
    thumbWrap.appendChild(thumb);
  }

  function shouldFilterMainSlides() {
    return true;
  }

  function ensureThuleSpringDefaultVariant(container) {
    if (!isThuleSpringMainListing() || container.__ckThuleSpringDefaulted) return;
    if (window.location.search && /(?:[?&])variant=/.test(window.location.search)) return;

    var blackInput = Array.prototype.slice.call(container.querySelectorAll('[data-variant-input]')).find(function(input) {
      return input.value === 'Black';
    });
    if (!blackInput || blackInput.checked) {
      container.__ckThuleSpringDefaulted = true;
      return;
    }

    blackInput.checked = true;
    var blackVariant = variantsFor(container).find(function(variant) {
      return variant.option1 === 'Black' || variant.option2 === 'Black' || variant.option3 === 'Black';
    });
    var select = container.querySelector('[data-product-select]');
    if (select && blackVariant) {
      select.value = blackVariant.id;
    }

    container.__ckThuleSpringDefaulted = true;
    blackInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function gallerySlideParent(container) {
    var slider = gallerySlider(container);
    if (!slider || !window.Flickity) return null;

    var flkty = window.Flickity.data(slider);
    return (flkty && flkty.slider) || slider.querySelector('.flickity-slider');
  }

  function hiddenSlideDeck(container) {
    var slider = gallerySlider(container);
    if (!slider) return null;

    if (!slider.__ckGalleryHiddenDeck) {
      var deck = document.createElement('div');
      deck.className = 'ck-gallery-hidden-deck';
      deck.hidden = true;
      slider.appendChild(deck);
      slider.__ckGalleryHiddenDeck = deck;
    }

    return slider.__ckGalleryHiddenDeck;
  }

  function orderedMainSlides(container) {
    var slides = Array.prototype.slice.call(container.querySelectorAll('.product-main-slide'));
    slides.forEach(function(slide, index) {
      if (!slide.hasAttribute('data-ck-original-index')) {
        slide.setAttribute('data-ck-original-index', String(index));
      }
    });

    return slides.sort(function(a, b) {
      return Number(a.getAttribute('data-ck-original-index') || 0) -
        Number(b.getAttribute('data-ck-original-index') || 0);
    });
  }

  function findVariantThumb(container, variant) {
    var targetFile = cleanFile(variantImageSrc(variant));
    if (!targetFile) return null;

    var found = null;
    container.querySelectorAll('.product__thumb').forEach(function(thumb) {
      if (found) return;
      if (cleanFile(thumb.getAttribute('href')) === targetFile) {
        found = thumb;
      }
    });
    return found;
  }

  function visibleSelectedSlide(container) {
    var slides = Array.prototype.slice.call(container.querySelectorAll('.product-main-slide.is-selected'));
    var visible = slides.find(function(slide) {
      var rect = slide.getBoundingClientRect();
      return rect.width > 20 && rect.height > 20;
    });
    return visible || slides[0] || container.querySelector('.product-main-slide');
  }

  function mediaColorFromElements(link, image) {
    return colorToken([
      link && link.getAttribute('data-group'),
      image && image.getAttribute('data-group'),
      closestGroup(link),
      closestGroup(image),
      image && image.getAttribute('alt'),
      image && image.getAttribute('src'),
      image && image.getAttribute('srcset'),
      image && image.currentSrc,
      link && link.getAttribute('href')
    ].join(' '));
  }

  function syncColorThumbnails(container, variant) {
    var selectedColor = variantColorToken(variant, container);
    if (!selectedColor) return;

    container.querySelectorAll('.product__thumb-item').forEach(function(item) {
      var link = item.querySelector('.product__thumb');
      var image = item.querySelector('img');
      var mediaColor = mediaColorFromElements(link, image);
      var mediaFile = cleanFile((link && link.getAttribute('href')) || (image && (image.currentSrc || image.src)));
      var exactColorFile = thuleSpringFileMatchesColor(mediaFile, selectedColor);
      var shouldHide = Boolean(mediaColor && mediaColor !== selectedColor && !exactColorFile);
      item.classList.toggle('hide', shouldHide);
      item.classList.toggle('ck-color-hidden', shouldHide);
      if (shouldHide) {
        item.style.setProperty('display', 'none', 'important');
        item.setAttribute('aria-hidden', 'true');
        item.hidden = true;
      } else {
        item.style.removeProperty('display');
        item.removeAttribute('aria-hidden');
        item.hidden = false;
      }
    });
  }

  function visibleThumbItems(container) {
    return Array.prototype.slice.call(container.querySelectorAll('.product__thumb-item')).filter(function(item) {
      return !item.hidden &&
        !item.classList.contains('hide') &&
        !item.classList.contains('ck-color-hidden') &&
        item.style.display !== 'none';
    });
  }

  function syncThumbRailState(container) {
    var rail = container.querySelector('[data-product-thumbs]');
    if (!rail) return;

    var visibleCount = visibleThumbItems(container).length;
    var isSingle = visibleCount <= 1;
    rail.classList.toggle('ck-single-visible-thumb', isSingle);
    rail.classList.toggle('ck-multiple-visible-thumbs', visibleCount > 1);
    rail.setAttribute('data-ck-visible-thumbs', String(visibleCount));

    rail.querySelectorAll('.product__thumb-arrow').forEach(function(arrow) {
      arrow.hidden = isSingle;
      if (isSingle) {
        arrow.setAttribute('aria-hidden', 'true');
      } else {
        arrow.removeAttribute('aria-hidden');
      }
    });
  }

  function lockGalleryHeight(container, selectedColor) {
    var slider = container.querySelector('[data-product-photos]');
    if (!slider) return;

    var viewport = slider.querySelector('.flickity-viewport');
    var rect = viewport ? viewport.getBoundingClientRect() : slider.getBoundingClientRect();
    var width = Math.round(rect.width || slider.getBoundingClientRect().width || 0);
    var height = Math.round(rect.height || 0);

    if (height < 120) {
      var selected = slider.querySelector('.product-main-slide.is-selected img') || slider.querySelector('.product-main-slide img');
      if (selected) {
        height = Math.round(selected.getBoundingClientRect().height || 0);
      }
    }

    container.querySelectorAll('.product-main-slide').forEach(function(slide) {
      var mediaColor = slideColor(slide);
      if (selectedColor && mediaColor && mediaColor !== selectedColor) return;

      var slideRect = slide.getBoundingClientRect();
      if (slideRect.height > height) {
        height = Math.round(slideRect.height);
      }

      var image = slide.querySelector('img');
      if (!image) return;

      var imageRect = image.getBoundingClientRect();
      if (imageRect.height > height) {
        height = Math.round(imageRect.height);
      }

      if (width >= 120 && image.naturalWidth && image.naturalHeight) {
        var naturalHeight = Math.round(width * image.naturalHeight / image.naturalWidth);
        if (naturalHeight > height) {
          height = naturalHeight;
        }
      }
    });

    var current = parseInt(slider.style.getPropertyValue('--ck-gallery-min-height'), 10);
    if (current && current > height) {
      height = current;
    }

    if (height >= 120) {
      slider.classList.add('ck-gallery-height-locked');
      slider.style.setProperty('--ck-gallery-min-height', height + 'px');
    }
  }

  function syncColorSlides(container, variant) {
    var selectedColor = variantColorToken(variant, container);
    if (!selectedColor) return;

    lockGalleryHeight(container, selectedColor);
    var filterMainSlides = shouldFilterMainSlides();
    var visibleMatchCount = 0;
    var firstVisibleMatch = null;

    container.querySelectorAll('.product-main-slide').forEach(function(slide) {
      var mediaColor = slideColor(slide);
      var exactColorFile = thuleSpringFileMatchesColor(slideFile(slide), selectedColor);
      var shouldHide = Boolean(mediaColor && mediaColor !== selectedColor && !exactColorFile);
      slide.classList.toggle('ck-color-hidden', filterMainSlides && shouldHide);
      if (filterMainSlides && shouldHide) {
        slide.style.setProperty('display', 'none', 'important');
        slide.style.setProperty('visibility', 'hidden', 'important');
        slide.style.setProperty('pointer-events', 'none', 'important');
        slide.setAttribute('aria-hidden', 'true');
        slide.setAttribute('tabindex', '-1');
      } else {
        slide.classList.remove('hide');
        slide.hidden = false;
        slide.style.removeProperty('display');
        slide.style.removeProperty('visibility');
        slide.style.removeProperty('pointer-events');
        slide.removeAttribute('aria-hidden');
        slide.removeAttribute('tabindex');

        if (!mediaColor || mediaColor === selectedColor || exactColorFile) {
          visibleMatchCount += 1;
          if (!firstVisibleMatch) {
            firstVisibleMatch = slide;
          }
        }
      }
    });

    if (filterMainSlides && visibleMatchCount === 0) {
      firstVisibleMatch = firstExactSlideForColor(container, selectedColor) || firstSlideForColor(container, selectedColor);
      revealSlide(firstVisibleMatch);
    }

    syncSelectedSlideClass(container, selectedColor, selectedUsableSlide(container, selectedColor) || firstVisibleMatch);
  }

  function slideColor(slide) {
    if (!slide) return '';
    return colorToken([
      slide.getAttribute('data-group'),
      slide.getAttribute('data-set-name'),
      mediaColorFromElements(slide.querySelector('a[href]'), slide.querySelector('img'))
    ].join(' '));
  }

  function revealSlide(slide) {
    if (!slide) return;
    slide.classList.remove('hide');
    slide.classList.remove('ck-color-hidden');
    slide.hidden = false;
    slide.style.removeProperty('display');
    slide.style.removeProperty('visibility');
    slide.style.removeProperty('pointer-events');
    slide.removeAttribute('aria-hidden');
    slide.removeAttribute('tabindex');
  }

  function firstExactSlideForColor(container, color) {
    if (!color) return null;
    var match = null;
    container.querySelectorAll('.product-main-slide').forEach(function(slide) {
      if (match) return;
      if (slideColor(slide) === color) {
        match = slide;
      }
    });
    return match;
  }

  function selectedUsableSlide(container, selectedColor) {
    var match = null;
    container.querySelectorAll('.product-main-slide.is-selected').forEach(function(slide) {
      if (match) return;
      if (slideUsableForColor(slide, selectedColor)) {
        match = slide;
      }
    });
    return match;
  }

  function syncSelectedSlideClass(container, selectedColor, preferredSlide) {
    var target = preferredSlide;
    if (!slideUsableForColor(target, selectedColor)) {
      target = selectedUsableSlide(container, selectedColor);
    }
    if (!slideUsableForColor(target, selectedColor)) {
      target = firstExactSlideForColor(container, selectedColor) || firstSlideForColor(container, selectedColor);
    }
    if (!target) return null;

    revealSlide(target);
    container.querySelectorAll('.product-main-slide.is-selected').forEach(function(slide) {
      if (slide !== target) {
        slide.classList.remove('is-selected');
      }
    });
    target.classList.add('is-selected');
    syncActiveThumbForSlide(container, target);
    return target;
  }

  function activeSlide(container) {
    var slider = container.querySelector('[data-product-photos]');
    if (window.Flickity && slider) {
      var flkty = window.Flickity.data(slider);
      if (flkty && flkty.selectedElement) return flkty.selectedElement;
    }

    return container.querySelector('.product-main-slide.is-selected') ||
      container.querySelector('.product-main-slide');
  }

  function slideFile(slide) {
    if (!slide) return '';
    var link = slide.querySelector('a[href]');
    var image = slide.querySelector('img');
    return cleanFile((link && link.getAttribute('href')) || (image && (image.currentSrc || image.src)));
  }

  function syncActiveThumbForSlide(container, slide) {
    var file = slideFile(slide);
    if (!file) return;

    container.querySelectorAll('.product__thumb').forEach(function(thumb) {
      thumb.classList.toggle('is-active', cleanFile(thumb.getAttribute('href')) === file);
    });
  }

  function firstSlideForColor(container, color) {
    var match = null;
    container.querySelectorAll('.product-main-slide').forEach(function(slide) {
      if (match) return;
      var mediaColor = slideColor(slide);
      if (!mediaColor || mediaColor === color || thuleSpringFileMatchesColor(slideFile(slide), color)) {
        match = slide;
      }
    });
    return match;
  }

  function slideUsableForColor(slide, selectedColor) {
    if (!slide || slide.hidden || slide.classList.contains('ck-color-hidden')) return false;
    var style = window.getComputedStyle ? window.getComputedStyle(slide) : null;
    if (style && (style.display === 'none' || style.visibility === 'hidden')) return false;

    var mediaColor = slideColor(slide);
    return !selectedColor || !mediaColor || mediaColor === selectedColor || thuleSpringFileMatchesColor(slideFile(slide), selectedColor);
  }

  function findSlideByFile(container, file, selectedColor) {
    if (!file) return null;
    var match = null;
    container.querySelectorAll('.product-main-slide').forEach(function(slide) {
      if (match) return;
      if (slideFile(slide) === file && slideUsableForColor(slide, selectedColor)) {
        match = slide;
      }
    });
    return match;
  }

  function selectSlide(container, slide, instant) {
    if (!slide) return false;
    var slider = container.querySelector('[data-product-photos]');
    if (!slider) return false;

    if (window.Flickity) {
      var flkty = window.Flickity.data(slider);
      if (flkty && typeof flkty.selectCell === 'function') {
        flkty.selectCell(slide, Boolean(instant), true);
        return true;
      }
    }

    if (slider.__ckSlideshow && typeof slider.__ckSlideshow.goToSlide === 'function') {
      var mediaId = slide.dataset.mediaId;
      var index = slide.dataset.index;
      slider.__ckSlideshow.goToSlide(mediaId || index || 0);
      return true;
    }

    return false;
  }

  function refreshGalleryCells(container, selectedColor, options) {
    var slider = container.querySelector('[data-product-photos]');
    if (!slider || !window.Flickity) return;

    var flkty = window.Flickity.data(slider);
    if (!flkty) return;
    options = options || {};

    var selectedBefore = flkty.selectedElement || activeSlide(container);
    var selectedFile = slideFile(selectedBefore);

    if (typeof flkty.reloadCells === 'function') {
      flkty.reloadCells();
    }
    if (typeof flkty.resize === 'function') {
      flkty.resize();
    }

    var fallbackTarget = firstExactSlideForColor(container, selectedColor) || firstSlideForColor(container, selectedColor);
    revealSlide(fallbackTarget);

    var target = options.resetSelection
      ? fallbackTarget
      : findSlideByFile(container, selectedFile, selectedColor);

    if (!target && !options.resetSelection && slideUsableForColor(selectedBefore, selectedColor)) {
      target = selectedBefore;
    }

    if (!target && options.resetSelection) {
      target = fallbackTarget;
    }

    if (target && typeof flkty.selectCell === 'function') {
      revealSlide(target);
      flkty.selectCell(target, true, true);
      syncSelectedSlideClass(container, selectedColor, target);
    }
  }

  function gallerySlider(container) {
    return container.querySelector('[data-product-photos]');
  }

  function gallerySlides(container, selectedColor) {
    var slider = gallerySlider(container);
    if (!slider) return [];

    var slides = Array.prototype.slice.call(slider.querySelectorAll('.product-main-slide'));
    if (!selectedColor) {
      return slides.filter(function(slide) {
        return !slide.classList.contains('ck-color-hidden');
      });
    }

    var filtered = slides.filter(function(slide) {
      var mediaColor = slideColor(slide);
      return !mediaColor || mediaColor === selectedColor || thuleSpringFileMatchesColor(slideFile(slide), selectedColor);
    });
    return filtered.length ? filtered : slides;
  }

  function usableGallerySlides(container, selectedColor) {
    return gallerySlides(container, selectedColor).filter(function(slide) {
      return slideUsableForColor(slide, selectedColor);
    });
  }

  function indicatorFrame(slider) {
    if (!slider) return null;
    return slider.closest('.product__main-photos') ||
      slider.closest('.product__photos') ||
      slider.parentElement;
  }

  function ensureGalleryIndicator(container) {
    var slider = gallerySlider(container);
    var frame = indicatorFrame(slider);
    if (!slider || !frame) return null;

    frame.classList.add('ck-gallery-indicator-frame');

    var pill = frame.querySelector('.ck-gallery-count-pill');
    if (!pill) {
      pill = document.createElement('div');
      pill.className = 'ck-gallery-count-pill';
      pill.setAttribute('aria-hidden', 'true');
      frame.appendChild(pill);
    }

    var dots = frame.querySelector('.ck-gallery-dots');
    if (!dots) {
      dots = document.createElement('div');
      dots.className = 'ck-gallery-dots';
      dots.setAttribute('aria-hidden', 'true');
      if (slider.parentElement === frame) {
        frame.insertBefore(dots, slider.nextSibling);
      } else {
        slider.insertAdjacentElement('afterend', dots);
      }
    }

    return {
      slider: slider,
      frame: frame,
      pill: pill,
      dots: dots
    };
  }

  function currentGalleryIndex(container, slides, slider) {
    var selected = null;
    if (window.Flickity && slider) {
      var flkty = window.Flickity.data(slider);
      if (flkty) {
        selected = flkty.selectedElement || (flkty.selectedElements && flkty.selectedElements[0]);
      }
    }

    selected = selected || activeSlide(container) || visibleSelectedSlide(container);

    var index = slides.indexOf(selected);
    if (index !== -1) return index;

    var selectedFile = slideFile(selected);
    if (selectedFile) {
      for (var i = 0; i < slides.length; i += 1) {
        if (slideFile(slides[i]) === selectedFile) return i;
      }
    }

    return 0;
  }

  function syncGalleryIndicator(container, variant) {
    var indicator = ensureGalleryIndicator(container);
    if (!indicator) return;

    var selectedColor = variantColorToken(variant, container);
    var slides = gallerySlides(container, selectedColor);
    var count = slides.length;

    if (count < 2) {
      indicator.pill.hidden = true;
      indicator.dots.hidden = true;
      return;
    }

    var index = currentGalleryIndex(container, slides, indicator.slider);
    if (index < 0 || index >= count) index = 0;

    indicator.pill.hidden = false;
    indicator.dots.hidden = false;
    indicator.pill.textContent = (index + 1) + ' / ' + count;

    if (indicator.dots.children.length !== count) {
      indicator.dots.textContent = '';
      for (var i = 0; i < count; i += 1) {
        var dot = document.createElement('span');
        dot.className = 'ck-gallery-dot';
        indicator.dots.appendChild(dot);
      }
    }

    Array.prototype.forEach.call(indicator.dots.children, function(dot, dotIndex) {
      dot.classList.toggle('is-active', dotIndex === index);
    });
  }

  function syncGalleryIndicatorSoon(container) {
    var run = function() {
      var variant = selectedVariant(container);
      if (variant) syncGalleryIndicator(container, variant);
    };
    run();
    window.setTimeout(run, 80);
    window.setTimeout(run, 240);
  }

  function installThumbnailSelectGuard(container) {
    if (!container || container.__ckVariantThumbSelectGuardAttached) return;
    container.__ckVariantThumbSelectGuardAttached = true;

    container.addEventListener('click', function(event) {
      var link = event.target && event.target.closest && event.target.closest('a.product__thumb[href]');
      if (!link || !container.contains(link)) return;

      var file = cleanFile(link.getAttribute('href'));
      if (!file) return;

      var variant = selectedVariant(container);
      var selectedColor = variantColorToken(variant, container);
      var target = findSlideByFile(container, file, selectedColor);
      if (!target) {
        container.querySelectorAll('.product-main-slide').forEach(function(slide) {
          if (!target && slideFile(slide) === file) {
            var mediaColor = slideColor(slide);
            if (!selectedColor || !mediaColor || mediaColor === selectedColor) {
              target = slide;
            }
          }
        });
      }
      if (!target) return;

      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) {
        event.stopImmediatePropagation();
      }

      revealSlide(target);
      container.querySelectorAll('.product__thumb').forEach(function(thumb) {
        thumb.classList.toggle('is-active', thumb === link);
      });
      selectSlide(container, target, false);
      syncSelectedSlideClass(container, selectedColor, target);
      syncGalleryIndicatorSoon(container);
      window.setTimeout(function() { syncContainer(container, { forceImage: false }); }, 120);
      window.setTimeout(function() { syncContainer(container, { forceImage: false }); }, 520);
    }, true);
  }

  function installSwipeFallback(container) {
    var slider = gallerySlider(container);
    if (!slider || slider.__ckVariantSwipeFallbackAttached) return;
    slider.__ckVariantSwipeFallbackAttached = true;

    var start = null;

    slider.addEventListener('touchstart', function(event) {
      if (!event.touches || event.touches.length !== 1) return;
      var touch = event.touches[0];
      start = {
        x: touch.clientX,
        y: touch.clientY,
        file: slideFile(activeSlide(container))
      };
    }, { passive: true });

    slider.addEventListener('touchend', function(event) {
      if (!start || !event.changedTouches || !event.changedTouches.length) {
        start = null;
        return;
      }

      var touch = event.changedTouches[0];
      var dx = touch.clientX - start.x;
      var dy = touch.clientY - start.y;
      var startFile = start.file;
      start = null;

      if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy) * 1.2) return;

      window.setTimeout(function() {
        var current = activeSlide(container);
        if (slideFile(current) !== startFile) return;

        var variant = selectedVariant(container);
        var selectedColor = variantColorToken(variant, container);
        var slides = usableGallerySlides(container, selectedColor);
        if (slides.length < 2) return;

        var index = currentGalleryIndex(container, slides, slider);
        var direction = dx < 0 ? 1 : -1;
        var nextIndex = (index + direction + slides.length) % slides.length;
        selectSlide(container, slides[nextIndex], false);
        window.setTimeout(function() { syncContainer(container, { forceImage: false }); }, 220);
        syncGalleryIndicatorSoon(container);
      }, 140);
    }, { passive: true });
  }

  function keepSelectedColor(container, variant) {
    var selectedColor = variantColorToken(variant, container);
    if (!selectedColor) return;

    var selected = activeSlide(container);
    if (!selected || slideColor(selected) === selectedColor || !slideColor(selected)) return;

    selectSlide(container, firstSlideForColor(container, selectedColor), true);
  }

  function keepSelectedColorSoon(container) {
    var run = function() {
      var variant = selectedVariant(container);
      if (variant) {
        keepSelectedColor(container, variant);
        syncGalleryIndicator(container, variant);
      }
    };
    run();
    window.setTimeout(run, 60);
    window.setTimeout(run, 180);
    window.setTimeout(run, 360);
  }

  function forceMainImage(container, variant) {
    var src = variantImageSrc(variant);
    if (!src) return;

    var selectedColor = variantColorToken(variant, container);
    var targetFile = cleanFile(src);
    var thumb = findVariantThumb(container, variant);
    var slider = container.querySelector('[data-product-photos]');

    var targetSlide = null;
    container.querySelectorAll('.product-main-slide').forEach(function(slide) {
      if (targetSlide) return;
      var link = slide.querySelector('a[href]');
      var image = slide.querySelector('img');
      if (cleanFile((link && link.getAttribute('href')) || (image && (image.currentSrc || image.src))) === targetFile) {
        targetSlide = slide;
      }
    });

    revealSlide(targetSlide);
    if (!selectSlide(container, targetSlide, true) && thumb) {
      container.querySelectorAll('.product__thumb').forEach(function(item) {
        item.classList.toggle('is-active', item === thumb);
      });
    }

    syncSelectedSlideClass(container, selectedColor, targetSlide);

    var activeSlide = targetSlide || visibleSelectedSlide(container);
    if (!activeSlide) return;
    var activeColor = slideColor(activeSlide);
    if (selectedColor && activeColor && activeColor !== selectedColor) return;

    var image = activeSlide.querySelector('img');
    if (!image) return;

    if (cleanFile(image.currentSrc || image.src) !== targetFile) {
      image.removeAttribute('srcset');
      image.removeAttribute('data-srcset');
      image.src = displaySrc(src);
    }

    var alt = variant.featured_image && variant.featured_image.alt ? variant.featured_image.alt : '';
    if (alt) image.setAttribute('alt', alt);

    var link = activeSlide.querySelector('a[href]');
    if (link) link.setAttribute('href', src);

    if (thumb) {
      container.querySelectorAll('.product__thumb').forEach(function(item) {
        item.classList.toggle('is-active', item === thumb);
      });
    }
  }

  function syncContainer(container, options) {
    if (container.__ckVariantGallerySyncing) return;
    ensureThuleSpringDefaultVariant(container);
    var variant = selectedVariant(container);
    if (!variant) return;
    options = options || {};
    container.__ckVariantGallerySyncing = true;
    try {
      var variantChanged = String(container.__ckVariantGalleryVariantId || '') !== String(variant.id || '');
      var selectedColor = variantColorToken(variant, container);
      ensureThuleSpringWheelKitSlide(container);
      syncColorThumbnails(container, variant);
      syncThumbRailState(container);
      syncColorSlides(container, variant);
      refreshGalleryCells(container, selectedColor, { resetSelection: options.forceImage || variantChanged });
      if (options.forceImage || variantChanged) {
        forceMainImage(container, variant);
      } else {
        keepSelectedColor(container, variant);
      }
      syncSelectedSlideClass(container, selectedColor);
      container.__ckVariantGalleryVariantId = variant.id;
      syncGalleryIndicator(container, variant);

      var slider = container.querySelector('[data-product-photos]');
      if (slider && slider.__ckSlideshow && typeof slider.__ckSlideshow.reposition === 'function') {
        slider.__ckSlideshow.reposition();
      }
    } finally {
      container.__ckVariantGallerySyncing = false;
    }
  }

  function watchSlider(container) {
    var slider = container.querySelector('[data-product-photos]');
    if (!slider || slider.__ckVariantSwipeGuardAttached) return;

    var attach = function() {
      if (!slider.__ckSlideshow || !slider.__ckSlideshow.slideshow || slider.__ckVariantSwipeGuardAttached) return;
      slider.__ckVariantSwipeGuardAttached = true;
      var flkty = slider.__ckSlideshow.slideshow;
      var markDragging = function() {
        slider.__ckVariantGalleryDragging = true;
        var variant = selectedVariant(container);
        lockGalleryHeight(container, variantColorToken(variant, container));
        slider.classList.add('ck-gallery-height-locked');
      };
      var settle = function() {
        window.setTimeout(function() {
          slider.__ckVariantGalleryDragging = false;
        }, 180);
        keepSelectedColorSoon(container);
        window.setTimeout(function() { syncContainer(container, { forceImage: false }); }, 260);
        window.setTimeout(function() { syncContainer(container, { forceImage: false }); }, 780);
        window.setTimeout(function() { syncContainer(container, { forceImage: false }); }, 1500);
        syncGalleryIndicatorSoon(container);
      };
      flkty.on('dragStart', markDragging);
      flkty.on('dragMove', markDragging);
      flkty.on('scroll', function() { syncGalleryIndicatorSoon(container); });
      flkty.on('dragEnd', settle);
      flkty.on('change', settle);
      flkty.on('settle', settle);
      window.setTimeout(function() { syncContainer(container, { forceImage: false }); }, 120);
      window.setTimeout(function() { syncContainer(container, { forceImage: false }); }, 700);
      window.setTimeout(function() { syncContainer(container, { forceImage: false }); }, 1400);
    };

    attach();
    window.setTimeout(attach, 250);
    window.setTimeout(attach, 900);
  }

  function watchContainer(container) {
    if (!isObservableContainer(container)) return;
    if (!container || container.__ckVariantGalleryObserver) return;
    container.__ckVariantGalleryObserver = new MutationObserver(function() {
      if (container.__ckVariantGallerySyncing) return;
      window.clearTimeout(container.__ckVariantGalleryObserverTimer);
      container.__ckVariantGalleryObserverTimer = window.setTimeout(function() {
        var slider = container.querySelector('[data-product-photos]');
        if (slider && slider.__ckVariantGalleryDragging) {
          container.__ckVariantGalleryObserverTimer = window.setTimeout(function() {
            syncContainer(container, { forceImage: false });
          }, 220);
          return;
        }
        syncContainer(container, { forceImage: false });
      }, 160);
    });
    container.__ckVariantGalleryObserver.observe(container, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'src', 'srcset', 'alt']
    });
  }

  function syncAll() {
    installDirectImageLinkGuard();
    ensureGalleryFilterStyle();
    var seen = [];
    document.querySelectorAll('[data-variant-json]').forEach(function(json) {
      var container = productContainer(json);
      if (!isObservableContainer(container)) return;
      if (seen.indexOf(container) !== -1) return;
      seen.push(container);
      watchSlider(container);
      installSwipeFallback(container);
      installThumbnailSelectGuard(container);
      syncContainer(container, { forceImage: true });
      watchContainer(container);
    });
  }

  document.addEventListener('change', function(event) {
    if (!event.target || !event.target.matches || !event.target.matches('[data-variant-input]')) return;
    var container = productContainer(event.target);
    window.setTimeout(function() { syncContainer(container, { forceImage: true }); }, 0);
    window.setTimeout(function() { syncContainer(container, { forceImage: true }); }, 250);
    window.setTimeout(function() { syncContainer(container, { forceImage: true }); }, 900);
    window.setTimeout(function() { syncContainer(container, { forceImage: false }); }, 1800);
  }, true);

  document.addEventListener('click', function(event) {
    var label = event.target.closest && event.target.closest('label[for]');
    if (!label) return;
    var input = document.getElementById(label.getAttribute('for'));
    if (!input || !input.matches('[data-variant-input]')) return;
    var container = productContainer(input);
    window.setTimeout(function() { syncContainer(container, { forceImage: true }); }, 0);
    window.setTimeout(function() { syncContainer(container, { forceImage: true }); }, 250);
    window.setTimeout(function() { syncContainer(container, { forceImage: true }); }, 900);
    window.setTimeout(function() { syncContainer(container, { forceImage: false }); }, 1800);
  }, true);

  installDirectImageLinkGuard();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll);
  } else {
    syncAll();
  }

  document.addEventListener('page:loaded', syncAll);
  document.addEventListener('shopify:section:load', syncAll);
  window.setTimeout(syncAll, 250);
  window.setTimeout(syncAll, 900);
  window.setTimeout(syncAll, 1800);
  window.setTimeout(syncAll, 3000);
  window.setTimeout(syncAll, 5000);
})();
